export const AUTH_RETURN_TO_KEY = 'xyqar.onboarding.return_to';